var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2632 16.3636H4.68112V4.90909H13.2632V16.3636ZM13.2632 3.27273H4.68112C4.26728 3.27273 3.87039 3.44513 3.57777 3.75201C3.28514 4.05888 3.12074 4.4751 3.12074 4.90909V16.3636C3.12074 16.7976 3.28514 17.2138 3.57777 17.5207C3.87039 17.8276 4.26728 18 4.68112 18H13.2632C13.677 18 14.0739 17.8276 14.3665 17.5207C14.6591 17.2138 14.8235 16.7976 14.8235 16.3636V4.90909C14.8235 4.4751 14.6591 4.05888 14.3665 3.75201C14.0739 3.44513 13.677 3.27273 13.2632 3.27273ZM10.9226 0H1.56037C1.14654 0 0.749649 0.172402 0.457022 0.47928C0.164396 0.786158 0 1.20237 0 1.63636V13.0909H1.56037V1.63636H10.9226V0Z",
    fill: "#0029FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.c23d5d54.svg";
export { ForwardRef as ReactComponent };